import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/faqs';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-navy-950" data-id="element-49" data-mp="1hbgtc9p1fr26">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-50" data-mp="1cf02v8ud90lx">
        <h2 className="text-3xl font-extrabold text-center text-white mb-12" data-id="element-51" data-mp="1ccdpgsksnqvs">
          ❓ PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-4" data-id="element-52" data-mp="253f7r2jsa2jj">
          {faqs.map((faq, i) => <div key={faq.q} className="border border-silver/20 rounded-2xl overflow-hidden bg-navy-900/70" data-id="element-53" data-mp="2512u31l26eca" data-mpi={i}>
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none focus-visible:ring-2 focus-visible:ring-silver hover:bg-navy-800/60 transition-colors" aria-expanded={openIndex === i} data-id="element-54" data-mp="1v3y22l4j7onk">
                <span className="font-bold text-white pr-4" data-id="element-55" data-mp="1klvxs3pp5pyc">{faq.q}</span>
                <ChevronDownIcon className={`w-5 h-5 text-silver transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-56" data-mp="1pm1sxtv6dul6" />
              </button>

              <AnimatePresence initial={false} data-id="element-57" data-mp="1fmstilhjjnrf">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-58" data-mp="11vnvfnttn3j7">
                    <div className="px-6 pb-5 text-silver leading-relaxed border-t border-silver/15 pt-3" data-id="element-59" data-mp="n22lww0loxqd">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}